import { FeaturesConfigurationProject } from 'src/screens/shared/configuration/feature/FeaturesConfigurationProject'
import { PROJECT } from 'src/shared/constants/constants'

export const FeaturesConfigurationPfKapPage = () => {
  return <FeaturesConfigurationProject projectType={PROJECT.PF_KAP} />
}
